// extracted by mini-css-extract-plugin
export default {"customCheckbox":"ATMCheckbox_customCheckbox__sRr1S","ui":"ATMCheckbox_ui__f2QWV","checkbox":"ATMCheckbox_checkbox__OW2Ft","box":"ATMCheckbox_box__CdZJc"};